export { default as component } from "../../../../src/routes/[prefix]/(feature)/setting/contact/+page.svelte";